module.exports = __webpack_public_path__ + "static/main_img@2x-659f819a4d91dc9c09a661ea69451b1b.png";